import React, { Component } from 'react';
import { Tab, Button, Message } from 'semantic-ui-react';
import { Competition, User, Extra } from './Form';
//import { clone } from 'ramda';
import { withNamespaces } from 'react-i18next';
import { generate } from 'shortid';


class WorkshopTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTabIndex: 0
    };
  }
  
  render() {
    const {
      t,
      data,
      events,
      onEventUpdate,
      onCompetitionUpdate,
      onParticipantDataUpdate,
      onChange,
      onDelete,
      onTabChange
    } = this.props;

    const panes = [
      {
        menuItem: {
          key: generate(),
          icon: 'wrench',
          content: t('private:addWorkshop.steps.competition')
        },
        render: () =>
          <Tab.Pane>
            <Competition
              events={events}
              workshopId={data.workshopId}
              event={data.event}
              competition={data.competition}
              onEventUpdate={onEventUpdate}
              onCompetitionUpdate={onCompetitionUpdate}
            />
          </Tab.Pane>
      },
      {
        menuItem: {
          key: generate(),
          icon: 'graduation cap',
          content: t('private:addWorkshop.steps.participant')
        },
        render: () =>
          <Tab.Pane>
            <User data={data.userData} onChange={onParticipantDataUpdate} />
          </Tab.Pane>
      },
      {
        menuItem: {
          key: generate(),
          icon: 'info',
          content: t('private:addWorkshop.steps.extra')
        },
        render: () =>
          <Tab.Pane>
            <Extra data={data} onChange={onChange} />
          </Tab.Pane>
      }
    ];

    if (data.workshopId) {
      panes.push({
        menuItem: {
          key: generate(),
          icon: 'delete',
          content: t('common:delete')
        },
        render: () =>
          <Tab.Pane>
            <Message
              icon='exclamation triangle'
              content={t('private:addWorkshop.delete.warning')}
            />
            <Message warning/>
            <Button
              negative
              content={t('private:addWorkshop.delete.button')}
              onClick={onDelete}
            />
          </Tab.Pane>
      });
    }

    return (
      <Tab
        panes={panes}
        renderActiveOnly={true}
        onTabChange={onTabChange} />
    );
  };
};

export default withNamespaces(['private', 'common'])(WorkshopTab);



// WEBPACK FOOTER //
// ./src/private/common/components/Workshop/Tab.js